import type { ButtonProps } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { Tooltip, IconButton } from '@mui/material';

import { Iconify } from 'src/components/iconify';

type Coordinates = {
  lat: number;
  lng: number;
};

type LocationInput = string | Coordinates;

interface DirectionsButtonProps extends Omit<ButtonProps, 'onClick'> {
  origin: LocationInput;
  destination: LocationInput;
}

export function DirectionsButton({ origin, destination }: DirectionsButtonProps) {
  const { t } = useTranslation('common');
  const formatLocation = (location: LocationInput): string => {
    if (typeof location === 'string') {
      return location;
    }
    return `${location.lat},${location.lng}`;
  };

  const handleClick = () => {
    const formattedOrigin = formatLocation(origin);
    const formattedDestination = formatLocation(destination);

    const url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(formattedOrigin)}&destination=${encodeURIComponent(formattedDestination)}`;
    window.open(url, '_blank');
  };

  return (
    <Tooltip title={t('travel.getDirections')}>
      <IconButton
        onClick={handleClick}
    >
        <Iconify icon="solar:point-on-map-bold" />
      </IconButton>
    </Tooltip>
  );
} 